/* eslint-disable import/prefer-default-export */
const nameProps = ['nombre', 'apellido_paterno', 'apellido_materno'];
/**
 * Valida que se hayan ingresado al menos 2 parametros de nombre o ninguno
 * @param {Array} validProps
 * @returns boolean
 */
export const nameValidationSearch = (validProps = []) => nameProps
  .filter((p) => validProps.includes(p)).length !== 1;
